<template>
  <div class="layout-top">
    <!--<el-dialog
      :visible="dialogVisible"
      width="100%"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <span style="color: red">温馨提示：项目切换中，请稍后。。。</span>
    </el-dialog>-->
    <div class="logo" style="font-size: 20px; font-weight: bold">
      {{ appName }}
      <span style="margin-left: 5px; font-size: 12px; font-weight: bold">{{
        versions
      }}</span>
    </div>
    <div v-if="businessTypeShow">
      <!-- <el-button type="text" @click="switchTo">切换至 -- 大屏系统</el-button> -->
    </div>
    <div class="right-control">
      <div>
        <!--<el-select
          style="width: 450px; height: 80%"
          v-model="project"
          placeholder="请选择项目"
          value-key="id"
          @change="setProjectInfo()"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.projectName"
            :value="item"
          >
          </el-option>
        </el-select>-->
        <div class="contact">
          <span class="contact-text">技术支持电话：</span>
          <span class="contact-phone">88511155-6181</span>
        </div>
      </div>
      <div>您好,{{ nickName }}</div>
<!--      <div class="out" @click="editMessage">修改个人资料</div>-->
      <div class="out" @click="loginOut">退出</div>
    </div>
  </div>
</template>

<script>
import * as util from "@/assets/js/util.js";
import { login, getLoginInfo } from "@/api/api";
// import { getProjectListAll } from "@/api/system/project/project";
import crypto from "crypto";
export default {
  name: "layoutTop",
  data() {
    return {
      nickName: "",
      appName: process.env.VUE_APP_NAME,
      versions: null,
      projectList: null,
      project: null,
      dialogVisible: false,
      businessTypeShow: false
    };
  },
  mounted() {
    this.project = util.session("project");
    this.nickName = util.session("userInfo").userInfo.userName;
    this.businessType = util.session("userInfo").userInfo.businessType;
    /*if(this.businessType == "4"){
      this.businessTypeShow = true
    }else{
      this.businessTypeShow = false
    }
    this.versions = this.project.projectVersion;
    this.getProjectListAll();*/
  },
  methods: {
    switchTo() {
      this.$router.push("/echartsPage")
    },
    // getProjectListAll() {
    //   getProjectListAll().then((res) => {
    //     if (res.code == 200) {
    //       this.projectList = res.data;
    //     } else {
    //       this.$message.error(res.message);
    //     }
    //   });
    // },
    getLoginInfo() {
        var vm = this;
      getLoginInfo({
        userName: vm.$store.state.userInfo.loginName,
        projectId: vm.project.id,
      }).then((res) => {
        if (res.code == 200) {
          let businessType = res.data.businessType;
          util.session("menuList", { menuList: res.data.menuList });
          this.$store.dispatch("setMenuList", res.data.menuList);
          util.session("businessType", businessType);
          this.$store.dispatch("setBusinessType", businessType);
          util.session("projectEntityList", res.data.projectEntityList);
          this.$store.dispatch("setProject", this.project);
          util.session("project", this.project);
          this.versions = this.project.projectVersion;
          let PROJECT_APi_URL = this.project.serverContextPath;
          let arr = PROJECT_APi_URL.split("/");
          let url = "/" + arr[arr.length - 1];
          util.session("projectUrl", url);
          this.$store.dispatch("setProjectUrl", url);
          // util.session("projectWhiteEntity", res.data.projectWhiteEntity);
          // this.$store.dispatch("setProjectWhiteEntity", res.data.projectWhiteEntity);
          if (businessType == "2"||businessType == "8"||businessType == "10") {
            //渠道方
            util.session("userProjectRelation", {
              userProjectRelation: res.data.userProjectRelation,
            });
            this.$store.dispatch(
              "setUserProjectRelation",
              res.data.userProjectRelation
            );
            util.session("whiteYearMonth", {
              whiteYearMonth: res.data.whiteYearMonth,
            });
            this.$store.dispatch("setWhiteYearMonth", res.data.whiteYearMonth);
            util.session("whiteYearMonthName", {
              whiteYearMonthName: res.data.whiteYearMonthName,
            });
            this.$store.dispatch(
              "setWhiteYearMonthName",
              res.data.whiteYearMonthName
            );
            util.session("whiteListIsOpen", {
              whiteListIsOpen: res.data.whiteListIsOpen,
            });
            this.$store.dispatch(
              "setWhiteListIsOpen",
              res.data.whiteListIsOpen
            );
            util.session("supplementaryOpen", {
              supplementaryOpen: res.data.supplementaryOpen,
            });
            this.$store.dispatch(
              "setSupplementaryOpen",
              res.data.supplementaryOpen
            );
            util.session("currentPhase", {
              currentPhase: res.data.currentPhase,
            });
            this.$store.dispatch("setCurrentPhase", res.data.currentPhase);
          }
          if(businessType == "10"){
            util.session("privateKey",res.data.privateKey);
            this.$store.dispatch("setPrivateKey", res.data.privateKey);
          }
          util.session("auditOpen", { auditOpen: res.data.auditOpen });
          this.$store.dispatch("setAuditOpen", res.data.auditOpen);
          util.session("userInfo", { userInfo: res.data.user });
          this.$store.dispatch("setUserInfo", res.data.user);
          this.$store.state.meunuListChange = "YES";
          let menuArray = [];
          let menuList = res.data.menuList;
          menuList.forEach(function (item) {
            item.children = [];
            let pid = item.pid;
            if (pid == 0) {
              let objTemp = {
                ...item,
                pName: "没有上级",
                level: 1,
              };
              menuArray.push(objTemp);
            }
          });
          let treeData = this.data2treeDG(menuList, menuArray);
          if (treeData[0] && treeData[0].children) {
            let menuArray = this.sortArray(treeData[0].children);
            this.$store.dispatch("setMenuList", menuArray);
          }
          let routerUrl;
          if (businessType == "2"||businessType == "8"||businessType == "10") {
            //渠道方
            routerUrl = "/coupon/centerInfo/info";
          } else {
            //管理端、主办方、核销方
            if (businessType == "3") {
              //核销方
              routerUrl = "/coupon/report/list";
            } else if (businessType == "4") {
              //主办方
              routerUrl = "/coupon/whiteAudit/list";
            } else {
              routerUrl = "/home";
            }
          }
          if (this.$route.path != routerUrl) {
            this.$router.push({ path: routerUrl });
          }
          this.dialogVisible = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    setProjectInfo() {
      this.dialogVisible = true;
      // 切换项目，刷新菜单数据，刷新token，模拟登录
      let userName = this.$store.state.userInfo.loginName;
      let passWord = this.$store.state.userInfo.loginPassword;
      const key = 'gwF#EpPydZO1#v7E';
      const cipher = crypto.createCipheriv('aes-128-cbc', Buffer.from(key),"RandomInitVector");
      // 登录密码进行加密
      let encrypted = cipher.update(passWord, 'utf8', 'base64');
      encrypted += cipher.final('base64');
      let loginParams = {
        userName: userName,
        passWord: encrypted,
        projectId: this.project.id,
        type: "WEB",
      };
      login(loginParams).then((res) => {
        if (res.code == "200") {
          this.isBtnLoading = false;
          util.session("token", { token: res.data.token });
          this.$store.dispatch("setToken", res.data.token);
          this.$store.dispatch("setProject", this.project);
          this.getLoginInfo();
        } else {
          this.dialogVisible = false;
          this.project = util.session("project");
          this.$message.error(res.data.error[0].errorMsg);
        }
      });
    },
    data2treeDG(datas, dataArray) {
      for (let j = 0; j < dataArray.length; j++) {
        let dataArrayIndex = dataArray[j];
        let childrenArray = [];
        let Id = dataArrayIndex.id;
        let pName = dataArrayIndex.name;
        let level = dataArrayIndex.level + 1;
        for (let i = 0; i < datas.length; i++) {
          let data = datas[i];
          let pid = data.pid;
          if (pid == Id) {
            //判断是否为儿子节点

            let objTemp = {
              ...data,
              pName: pName,
              level: level,
              path: data.menuUrl,
              pType: dataArrayIndex.menuType,
            };

            childrenArray.push(objTemp);
          }
        }

        dataArrayIndex.children = childrenArray;
        if (childrenArray.length > 0) {
          //有儿子节点则递归
          this.data2treeDG(datas, childrenArray);
        }
      }
      return dataArray;
    },
    sortArray(array) {
      array.sort((a, b) => {
        return a.menuSort - b.menuSort;
      });
      array.forEach((item) => {
        if (item.children) {
          this.sortArray(item.children);
        }
      });

      return array;
    },
    loginOut() {
      this.$confirm("确定要退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.state.token="";
        this.$store.state.menuList=[];
        this.$router.push({ path: `/login` });
        //this.$router.go(0);
      });
    },
    editMessage() {
      this.$router.push({
        path: "/sys/user/info_own/" + this.$store.state.userInfo.id + "",
      });
    },
  },
};
</script>

<style scoped>
.layout-top {
  width: 100%;
  height: 60px;

  display: flex;
  justify-content: space-between;
  line-height: 60px;
  padding: 0 20px;
  box-sizing: border-box;
}

.out {
  cursor: pointer;
}

.right-control div {
  display: inline-block;
  margin-left: 20px;
}
.contact{
  position: absolute;
  top: 15px;
  left:45%;
  margin-top: -14px;
  margin-left: -100px;
  font-size: 16px;
  color: #FFFFFF;
  font-weight: 500;
}
</style>
